// Safeguard missing ad callbacks to prevent console errors
['al_onAppPaused', 'al_onAppResumed', 'al_onPoststitialDismiss', 'al_onAppWillResignActive'].forEach((method) => {
		window[method] = window[method] || function() {}
});

var saved_autocomplete_data = [];

(function ($) {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    document.querySelectorAll('.click-top').forEach(function(element) {
        element.addEventListener('click', function() {
            window.scrollTo(0, 0);
        });
    });

    updateNavVisibility();
    window.addEventListener('resize', function() {
        updateNavVisibility();
    });


    $('#header').on('click', '.open-search', function () {
        $('#search').toggleClass('show')
    });

    $('#header').on('click', '.open-search-mobile', function () {
        $('#search-mobile').toggleClass('show')
    });

    $(document).on("click", function (e) {
        // Check if the clicked element is not inside the dropdown
        if (!$(".checkbox-dropdown").is(e.target) && $(".checkbox-dropdown").has(e.target).length === 0) {
            // Close the dropdown
            $(".is-active").removeClass("is-active");
        }
    });

    $(".checkbox-dropdown").click(function (e) {
        e.stopPropagation(); // Prevent the click event from reaching the document
        if ($(this).hasClass("is-active")) {
            $(this).removeClass("is-active");
        } else {
            $(".is-active").removeClass("is-active");
            $(this).addClass("is-active");
        }
    });

    $(".checkbox-dropdown ul").click(function (e) {
        e.stopPropagation();
    });

    var customNavTop = $("#customNavTop");
    var customNavBottom = $("#customNavBottom").html();
    customNavTop.html(customNavBottom);

    var menuItem = $('.menu-left li');
    menuItem.each(function () {
        $(this).click(function () {
            var li = $(this).parents('li');
            if (!li.hasClass('active')) {
                var sumenu = $(this).find('.submenu-container');
                var close = sumenu.find('.close');
                var m = $(this);
                menuItem.removeClass('active');
                m.toggleClass('active');
                sumenu.slideDown();
            }
        });

        if($(".ui-menu-item-wrapper").hasClass('ui-state-active')) {
            $(this).addClass('selection_recherche_menu_destinations')
        }
        if(!$(".ui-menu-item-wrapper").hasClass('ui-state-active') && $(".ui-menu-item-wrapper").hasClass('selection_recherche_menu_destinations')) {
            $(this).removeClass('selection_recherche_menu_destinations')
        }
    });

    $(document).mouseup(function (e) {
        var container = $('.submenu-container');
        var li = menuItem.find('.menu-item');

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            menuItem.removeClass('active');
            li.removeClass('active');
            container.hide();
        }
    });

    $('li').find('.close').on('click', function (e) {
        e.stopPropagation();
        var li = $(this).parents('li');
        li.find('.submenu-container').slideUp();
        li.removeClass('active');
    });

    const width = $(window).width();
    const _header = $('#header');
    const navFixScroll = document.getElementById("navFixScroll");
    const sticky = navFixScroll ? navFixScroll.offsetTop - 133 : null;
    let ticking = false;

    if ($('.visite-page').length) {
        _header.addClass('fixed');
    } else {
        const onScroll = () => {
            const scrollY = window.pageYOffset || document.documentElement.scrollTop;

            if (!ticking) {
                requestAnimationFrame(() => {
                    if (width < 1200 || scrollY > 1) {
                        if (!navFixScroll || scrollY < sticky) {
                            _header.addClass('fixed');
                        } else {
                            _header.removeClass('fixed');
                        }
                    } else {
                        _header.removeClass('fixed');
                    }
                    ticking = false;
                });
                ticking = true;
            }
        };

        $(window).on('scroll', onScroll);
    }

    $('#menu-menu-top-left li').on("click",function () {
        $link = $(this).find('a');
        $arrow = $(this).find('.submenu-container .arrow-sub');
        $arrow2 = $(this).find('.submenu-container .arrow-sub2');
        $container = $(this).find('.submenu-container');
        $link_l = $link.position().left;
        
        if($container.position()) {
            if ($container.position().left !== undefined) {
                $container_l = $container.position().left;
            } else {
                $container_l = 0;
            }
        }

        $link_w = $link.width();
        $pos = $link_l + ($link_w / 2) - $container_l;
        $arrow2.css('left', $pos)
        $arrow.css('left', $pos)
    })


    $(window).resize(function () {
        $('#menu-menu-top-left li').each(function () {
            $link = $(this).find('a');
            $arrow = $(this).find('.submenu-container .arrow-sub');
            $arrow2 = $(this).find('.submenu-container .arrow-sub2');
			$container = $(this).find('.submenu-container');
            $link_l = $link.position().left;

			if ($container.position() !== undefined) {
				$container_l = $container.position().left;
			} else {
            	$container_l = 0;
			}

            $link_w = $link.width();
			$pos = $link_l + ($link_w / 2) - $container_l;
            $arrow2.css('left', $pos)
            $arrow.css('left', $pos)
        })
    });

    // SCROLL //
    $(".scroll").click(function(event) {
        event.preventDefault();  // Prévenir le comportement par défaut du lien

        const c = $(this).attr("href");
        const target = $(c);

        if (target.length) {
            requestAnimationFrame(() => {
                const targetPosition = target.offset().top - 144;

                $('html, body').animate({
                    scrollTop: targetPosition
                }, 800, "linear");
            });
        }
    });

    var nav = $('#produit-landing'),
        animateTime = 500,
        navLink = $('#toggle-produit');
    navLink.click(function () {
        if (nav.height() === 670) {
            autoHeightAnimate(nav, animateTime);
            $(this).hide();
        } else {
            nav.stop().animate({
                height: '0'
            }, animateTime);
        }
    });

    tag = $('.tag-container .tag.destinations')
    tag.on('click', function (evt) {
        evt.preventDefault();
        tag.removeClass('active');
        $(this).toggleClass('active');
        var sel = this.getAttribute('data-toggle-target');
        $('.tab-content').removeClass('active').filter(sel).addClass('active');
    });

    mobileTag = $('.submenu-mobile .menu-list a.destinations')
    mobileTag.on('click', function (evt) {
        evt.preventDefault();
        tag.removeClass('active');
        $('.submenu-mobile .page-one').removeClass('active');
        $('.submenu-mobile .page-two').addClass('active');
        $(this).toggleClass('active');
        var sel = this.getAttribute('data-toggle-target');
        $('.submenu-mobile .tab-content').removeClass('active').filter(sel).addClass('active');
    });

    tagEnvie = $('.envie-evenement .tag')
    tagEnvie.on('mouseover', function (evt) {
        evt.preventDefault();
        tagEnvie.removeClass('active');
        $(this).toggleClass('active');
        var sel = this.getAttribute('data-toggle-target');
        $('.tab-content').removeClass('active').filter(sel).addClass('active');
    });

    $('.listDdetail ul').addClass('d-flex flex-wrap');

    $('.sound audio').on('playing', function () {
        $('.sound .button--play').addClass('button--active');
    });

    $('.sound audio').on('ended', function () {
        $('.sound .button--play').removeClass('button--active');
    });

    var videoModal = $('#videoModal');
    if (videoModal.length > 0) {
        videoModal.modal({
            backdrop: false,
            show: false
        });

        function stopVideoModal() {
            var iframe = document.querySelector('#videoModal .video-youtube iframe') || document.querySelector('#videoModal iframe');
            if (iframe && iframe.contentWindow) {
                try {
                    iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
                } catch (e) {}
                iframe.src = 'about:blank';
            }
            var container = document.querySelector('#videoModal .video-youtube');
            if (container) {
                container.removeAttribute('data-src');
                container.innerHTML = '';
            }
        }

        var close = document.querySelector('#videoModal .close');
        if (close) {
            close.addEventListener('click', stopVideoModal);
        }
        videoModal.on('hidden.bs.modal', stopVideoModal);
    }

    const pause = "M11,10 L18,13.74 18,22.28 11,26 M18,13.74 L26,18 26,18 18,22.28";
    const play = "M11,10 L17,10 17,26 11,26 M20,10 L26,10 26,26 20,26";

    document.querySelectorAll('.sound').forEach(function(btn) {
        btn.addEventListener('click', function() {
            const sound = btn.querySelector('audio');
            const playBtn = btn.querySelector('.button--play');
            const animation = btn.querySelector('animate');

            // Alternance de l'état flip
            if(sound){
                const currentFlip = sound.dataset.flip === 'true';
                const newFlip = !currentFlip;

            // Mise à jour de l'animation
            if (animation) {
                animation.setAttribute('from', newFlip ? pause : play);
                animation.setAttribute('to', newFlip ? play : pause);
                animation.beginElement();
            }


                if (sound.paused) {
                    sound.play();
                    playBtn.classList.add('button--active');
                } else if (sound.ended) {
                    sound.currentTime = 0;
                    sound.play();
                    playBtn.classList.add('button--active');
                } else {
                    sound.pause();
                    playBtn.classList.remove('button--active');
                }

                // Mise à jour de la variable flip dans dataset
                sound.dataset.flip = newFlip;
            }
        });
    });

    $('.volume audio').on('playing', function () {
        $(this).parent().removeClass('volume-on');
        $(this).parent().addClass('volume-off');
        $(this).parent().prop('title', 'Arrêter le associé');
    });

    $('.volume audio').on('ended', function () {
        $(this).parent().removeClass('volume-off');
        $(this).parent().addClass('volume-on');
        $(this).parent().prop('title', 'Jouer le son associé');
    });

    $('.volume').on('click', function () {
        var btn = $(this);
        var sound = btn.find('audio');
        var soundS = sound[0];
        if (sound !== null && soundS !== undefined) {
            if (soundS.paused || soundS.ended) {
                if (soundS.ended) {
                    soundS.currentTime = 0;
                }
                soundS.play();
                btn.removeClass('volume-on');
                btn.addClass('volume-off');
                btn.prop('title', 'Arrêter le associé');
            } else {
                soundS.pause();
                btn.removeClass('volume-off');
                btn.addClass('volume-on');
                btn.prop('title', 'Jouer le son associé');
            }
        }
    });

//////// START - DROPDOWN SOUS MENU DESTINATIONS

    const navA = $("#navFixScroll li a");
    const navLi = $("#navFixScroll li");
    const navMain = $("#navFixScroll .navbar");

    navA.on('click', function (event) {
        event.stopPropagation(); // Prevent the click from immediately closing the dropdown

        const dropDown = this.parentNode.querySelector(".dropdown-menu");
        const share = this.parentNode.querySelector(".share-dropdown");
        const displayType = share ? "flex" : "block";

        const pos = dropDown ? this.getBoundingClientRect() : null;
        const targetOffset = this.hash && $(this.hash).length ? $(this.hash).offset().top : null;

        requestAnimationFrame(() => {
            if (dropDown) {
                if (dropDown.style.display === displayType) {
                    dropDown.style.display = "none";
                } else {
                    closeOpenDropdowns();
                    handleDropDownDisplay(dropDown, pos, displayType);
                }
            }

            navLi.removeClass('active');
            $(this).parent().addClass('active');

            if (targetOffset !== null) {
                $('html, body').animate({
                    scrollTop: targetOffset - 200
                }, 800, function () {
                    window.location.hash = this.hash;
                });
            }
        });
    });


    if (isMobile && navLi.length < 3) {
        navLi.first().css('border', 'none');
    }

    function handleDropDownDisplay(dropDown, pos, type) {
        dropDown.style.display = type;

        if (isMobile) {
            configureMobileDropDown(dropDown, pos);
        } else {
            configureDesktopDropDown(dropDown);
        }

        $(window).on('scroll', debounce(() => {
            if (dropDown.style.display === 'block' || dropDown.style.display === 'flex') {
                dropDown.style.display = "none";
            }
        }, 200));
    }

    function configureMobileDropDown(dropDown, pos) {
        dropDown.style.top = `${pos.top + 50}px`;
        dropDown.style.left = '20px';
        dropDown.style.right = '20px';
        dropDown.style.position = 'fixed';
    }

    function configureDesktopDropDown(dropDown) {
        dropDown.style.width = '20rem';
    }

    function closeOpenDropdowns() {
        $(".dropdown-menu").each(function () {
            if (this.style.display === 'block' || this.style.display === 'flex') {
                this.style.display = 'none';
            }
        });
    }

    $(document).on('click', function (event) {
        setTimeout(() => {
            if ($(event.target).closest('.dropdown-menu').length === 0) {
                closeOpenDropdowns();
            }
        }, 100); // Small delay to ensure dropdown open logic runs first
    });

    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

//////// END - DROPDOWN SOUS MENU DESTINATIONS

    var isshow = localStorage.getItem('isshow');
    if (isshow == null) {
        var shown = false;
        $(document).scroll(function() {
            if (!shown) {
                $( "#popup-home" ).show();
                shown = true;
            }
        })
    }

    $("#popup-home .close").on('click', function (e) {
        $( "#popup-home" ).hide();
        localStorage.setItem('isshow', 1);
    });

    $(".continent-slider-container").on('click', function (e) {
        e.preventDefault();
        window.location.href = $(this).find( ".slider-link" ).attr('href');
    });

//////// START - DROPDOWN PAGE PRODUIT
    var toggle = document.getElementById('circuit-dropdown-toggle');
    var menu = document.getElementById('circuit-dropdown-menu');
    if(toggle){
        toggle.addEventListener('click', function() {
            var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', !isExpanded);
            menu.classList.toggle('show');
        });

        // Close the dropdown if the user clicks outside of it
        document.addEventListener('click', function(event) {
            if (!toggle.contains(event.target) && !menu.contains(event.target)) {
                toggle.setAttribute('aria-expanded', 'false');
                menu.classList.remove('show');
            }
        });
    }

//////// END - DROPDOWN PAGE PRODUIT

})(jQuery);

/* Function to animate height: auto */
function autoHeightAnimate(element, time) {
    var curHeight = element.height(),
    autoHeight = element.css('height', 'auto').height();
    element.height(curHeight);
    element.stop().animate({
    height: autoHeight
    }, time);
}

function classToggle() {
    const nav = document.querySelector('.nav-mobile')
    const toggle = document.querySelector('.mobile-toggle')
    const body = document.querySelector('body')
    $('.nav-mobile').css('top', $('#header').height())
    $('.nav-mobile .menu .menu-item .dropdown-link').removeClass('active');
    toggle.classList.toggle('open')
    nav.classList.toggle('show')
    body.classList.toggle('nav-mobile-open')
}

jQuery(document).ready(function($) {
    if (document.querySelector('.mobile-toggle')) {
    document.querySelector('.mobile-toggle').addEventListener('click', classToggle);
    }

    $('.nav-mobile .menu .menu-item .dropdown-link').click(function (e) {
    $('.nav-mobile .menu .menu-item .dropdown-link').removeClass('active');
    $(this).addClass('active');
    e.preventDefault();
    });

    $('.back .close-mobile-modal').click(function (e) {
    $('.nav-mobile .menu .menu-item .dropdown-link').removeClass('active');
    e.preventDefault();
    });

    $('.back .close-mobile-modal-two').click(function (e) {
    $('.submenu-mobile .page-two').removeClass('active');
    $('.submenu-mobile .page-one').addClass('active');
    e.preventDefault();
    });

    // Crypter les liens dans les éléments avec la classe 'hidelink'
    document.querySelectorAll('.hidelink').forEach(function(element) {
        element.dataset.crypted = btoa(element.getAttribute('href'));
        element.removeAttribute('href');
    });

    // Crypter les liens dans les éléments avec la classe 'newtab' lors du clic
        document.querySelectorAll('.newtab').forEach(function(element) {
            element.addEventListener('click', function(event) {
                element.dataset.crypted = btoa(element.getAttribute('href'));
                element.removeAttribute('href');
            });
        });

    // Ouvrir les liens cryptés dans un nouvel onglet lors du clic sur les éléments avec la classe 'newtab'
        document.querySelectorAll('.newtab').forEach(function(element) {
            element.addEventListener('click', function(event) {
                event.preventDefault();
                window.open(atob(element.dataset.crypted), '_blank').focus();
            });
        });

    // Rediriger vers les liens cryptés lors du clic sur les éléments avec la classe 'hidelink'
        document.querySelectorAll('.hidelink').forEach(function(element) {
            element.addEventListener('click', function(event) {
                event.preventDefault();
                window.location.href = atob(element.dataset.crypted);
            });
        });


    let contentPourquoiHidden = document.querySelector('.contentPourquoi .hidden')
    if (contentPourquoiHidden) {
        contentPourquoiHidden.style.display = 'none'
    }

    /**
     * Masonry (API vanilla, sans jQuery), columnWidth via .grid-sizer.
     * @see https://masonry.desandro.com/options
     */
    (function initCdvMasonry() {
        var MasonryCtor = window.Masonry;
        if (typeof MasonryCtor !== 'function') {
            return;
        }
        console.log('MasonryCtor', MasonryCtor);
        var masonryOptions = {
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: true,
            horizontalOrder: true,
            gutter: 15
        };
        document.querySelectorAll('.grid').forEach(function (gridEl) {
            if (!gridEl.querySelector('.grid-sizer') || !gridEl.querySelector('.grid-item')) {
                return;
            }
            if (gridEl._cdvMasonryInstance) {
                gridEl._cdvMasonryInstance.destroy();
                gridEl._cdvMasonryInstance = null;
            }
            var msnry = new MasonryCtor(gridEl, masonryOptions);
            gridEl._cdvMasonryInstance = msnry;
            gridEl.querySelectorAll('img').forEach(function (img) {
                function relayout() {
                    msnry.layout();
                }
                if (img.complete) {
                    return;
                }
                img.addEventListener('load', relayout, { once: true });
                img.addEventListener('error', relayout, { once: true });
            });
        });
    })();

	$( '.dates_de_depart' ).on( 'click', function( e ) {
		let target = e.target
		$( '.dates_de_depart_placeholder' ).html( target.textContent )
	})

    document.querySelectorAll('.copyright').forEach(function(item) {
        item.parentElement.addEventListener('mouseover', function() {
            item.querySelector('.copyright-text').classList.remove('copyright-text-hide')
        })
        item.parentElement.addEventListener('mouseleave', function() {
            item.querySelector('.copyright-text').classList.add('copyright-text-hide')
        })
    })

    $(document).on('click', 'a.obs-link', function(e) {
        var url = $(this).data('url')
        if (url) {
            e.preventDefault()
            let decoded = new URL(atob(url))
            let envUrl = new URL(window.location.href)

            decoded.hostname = envUrl.hostname

            window.location = decoded
        }
    })



    let content_pourquoi = $('#content-pourquoi')
    let content_pourquoi_html = `${content_pourquoi.html()}<p><a href="#" id="less">Voir moins</a></p>`
    let content_pourquoi_text = `<p>${content_pourquoi.text().slice(0, 400)}... </p><p><a href="#" id="more">Lire la suite</a></p>`
    if (content_pourquoi.text().length > 400) {
        content_pourquoi.html(content_pourquoi_text)
    }

    content_pourquoi.on('click', 'a#more', function(e) {
        e.preventDefault()
        content_pourquoi.html(content_pourquoi_html)
    })

    content_pourquoi.on('click', 'a#less', function(e) {
        e.preventDefault()
        content_pourquoi.html(content_pourquoi_text)
    })
    $(document).find('.minimax').each(function(index, el) {
            el = $(el)
            let content_pourquoi_html = `${el.html()}<p><a href="#" id="less" class="link-cdv">Voir moins</a></p>`
            let content_pourquoi_text = `<p>${el.text().slice(0, 650)}... </p><p><a href="#" id="more" class="link-cdv">Lire la suite</a></p>`
            if (el.text().length > 650) {
                el.html(content_pourquoi_text)
            }

            el.on('click', 'a#more', function(e) {
                e.preventDefault()
                el.html(content_pourquoi_html)
            })

            el.on('click', 'a#less', function(e) {
                e.preventDefault()
                el.html(content_pourquoi_text)
            })

    })




});
function updateNavVisibility() {
    var navbar = document.querySelector('.navbar');
    var navFixScroll = document.getElementById('navFixScroll');
    if (navbar && !navbar.querySelector('li') &&  window.innerWidth <= 1200) {
        // Cache la div navFixScroll si la navbar est vide et en mode mobile
        navFixScroll.style.display = 'none';
    } else if(navbar && navFixScroll){
        navFixScroll.style.display = 'block';
    }
}